import { useTranslation } from 'react-i18next';

export const useStatutoryTimeframeExceededStatsLabels = (): Record<string, string> => {
  const { t } = useTranslation('statutory_timeframe_exceeded_stats_annual_dfi_report');

  const statutoryTimeframeExceededStatsLabels: Record<string, string> = {
    totalStatutoryConsultationsWithLateResponses: t(
      'total_statutory_consultations_with_late_responses',
      'Total number of statutory consultations with late responses'
    ),
    submittedWithin1To7DaysAfterDeadline: t(
      'total_statutory_consultations_with_late_responses_submitted_within_1_to_7_days_after_deadline',
      'Total number of statutory consultations with late responses submitted within 1-7 days after the agreed deadline'
    ),
    percentageStatutoryConsultationsWithLateResponsesSubmittedWithin1To7DaysAfterDeadline: t(
      'percentage_statutory_consultations_with_late_responses_submitted_within_1_to_7_days_after_deadline',
      'Percentage of statutory consultations with late responses submitted within 1-7 days after the agreed deadline'
    ),
    submittedWithin8To14DaysAfterDeadline: t(
      'total_statutory_consultations_with_late_responses_submitted_within_8_to_14_days_after_deadline',
      'Total number of statutory consultations with late responses submitted within 8-14 days after the agreed deadline'
    ),
    percentageStatutoryConsultationsWithLateResponsesSubmittedWithin8To14DaysAfterDeadline: t(
      'percentage_statutory_consultations_with_late_responses_submitted_within_8_to_14_days_after_deadline',
      'Percentage of statutory consultations with late responses submitted within 8-14 days after the agreed deadline'
    ),
    submittedWithin15To28DaysAfterDeadline: t(
      'total_statutory_consultations_with_late_responses_submitted_within_15_to_28_days_after_deadline',
      'Total number of statutory consultations with late responses submitted within 15-28 days after the agreed deadline'
    ),
    percentageStatutoryConsultationsWithLateResponsesSubmittedWithin15To28DaysAfterDeadline: t(
      'percentage_statutory_consultations_with_late_responses_submitted_within_15_to_28_days_after_deadline',
      'Percentage of statutory consultations with late responses submitted within 15-28 days after the agreed deadline'
    ),
    submittedOver29DaysAfterDeadline: t(
      'total_statutory_consultations_with_late_responses_submitted_over_29_days_after_deadline',
      'Total number of statutory consultations with late responses submitted over 29 days after the agreed deadline'
    ),
    percentageStatutoryConsultationsWithLateResponsesSubmittedOver29DaysAfterDeadline: t(
      'percentage_statutory_consultations_with_late_responses_submitted_over_29_days_after_deadline',
      'Percentage of statutory consultations with late responses submitted over 29 days after the agreed deadline'
    ),
  };

  return statutoryTimeframeExceededStatsLabels;
};
